import auth from "../../middlewares/auth";
export const settingsFolderSemesterRoute = [
  {
    path: '/settings/folder_semesters',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_semester/FolderSemesterList'),
    name: 'settings_folder_semester',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_semesters/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_semester/FolderSemesterForm'),
    name: 'settings_folder_semester_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_semesters/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_semester/FolderSemesterForm'),
    name: 'settings_folder_semester_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];